import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { BACKEND_URL } from "@/lib/api";

export default function QrRedirect() {
  const { code } = useParams();
  useEffect(() => {
    window.location.replace(`${BACKEND_URL}/api/q/${encodeURIComponent(code)}`);
  }, [code]);
  return <div className="min-h-screen bg-white" data-testid="qr-redirect" />;
}
